import styles from "./header_component.module.css";
import {Link, useNavigate} from "react-router-dom";
import {Avatar, Divider, Row, Tooltip, Typography} from "antd";
import {useAuth} from "../../context/AppAuthContext";
import {KeyOutlined, UserOutlined} from "@ant-design/icons";

export default function HeaderComponent() {
    const {user, isAuthenticated, logout} = useAuth();
    const navigate = useNavigate();

    function handleGoLanding() {
        navigate("/");
    }

    return (
        <div className={styles.header} draggable={false}>
            <div className={styles.brand} onClick={handleGoLanding}>
                <img className={styles.logo_image} src={'/resources/images/logo/logo.png'} alt="Tbadil"/>
                <p className={styles.logo_text}>Tbadil</p>
            </div>
            <AuthArea user={user} isAuthenticated={isAuthenticated} logout={logout}/>
        </div>
    )
}

function AuthArea({user, isAuthenticated, logout}) {
    const navigate = useNavigate();

    function handleLogin() {
        navigate("/login");
    }

    function handleLogout() {
        logout();
    }

    function handleGoProfile() {
        navigate("/profile");
    }

    function handleSignup() {
        navigate("/signup");
    }

    function handlePost() {
        navigate("/post");
    }

    // CHECK IF THE USER IS LOGGED IN
    if (isAuthenticated) {
        return (
            <div className={styles.user_area} draggable={false}>
                <Row className={styles.menu}>
                    <Typography.Link className={styles.menu_link}
                                     onClick={handlePost}
                    >
                        Post
                    </Typography.Link>
                    <Typography.Link className={styles.menu_link}>Browse</Typography.Link>
                    <Tooltip placement="bottom" title={"Profile"}>
                        {
                            user?.profile_picture === null || user?.profile_picture === undefined ?
                                <Avatar onClick={handleGoProfile} className={styles.user_avatar} icon={<UserOutlined/>}/>
                                :
                                <img onClick={handleGoProfile} className={styles.avatar}
                                     src={user.profile_picture}
                                     alt="avatar"/>
                        }
                    </Tooltip>
                    <Tooltip placement="bottom" title={"Logout"}>
                        <img className={styles.avatar}
                             src={'/resources/images/icons/logout_2.svg'}
                             onClick={handleLogout}
                             alt={"Logout"}/>
                    </Tooltip>
                </Row>
            </div>
        )
    }
    // USER IS NOT LOGGED IN
    return (
        <div className={styles.user_area} draggable={false}>
            <Row className={styles.menu}>
                <Typography.Link className={styles.menu_link} onClick={handleSignup}>Join</Typography.Link>
                <Typography.Link className={styles.menu_link}>Browse</Typography.Link>
                <Typography.Link className={styles.menu_link}>About</Typography.Link>
                <Tooltip placement="bottom" title={"Login"}>
                    <img className={styles.avatar} src={'/resources/images/icons/avatar.svg'}
                         onClick={handleLogin}
                         alt="Login"
                    />
                </Tooltip>
            </Row>
        </div>
    )
}